import { ApiClient } from '../api';
import { ApplicationContext } from '../components/context/application.context';
import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { AdSetResolveEvent } from '../components/event-manager/event/ad-set-resolve.event';
import { Events } from '../components/event-manager/event/events';
import { Logger } from '../components/logger/logger';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class AdSetSubscriber implements EventSubscriberInterface {
  public constructor (
    private readonly apiClient: ApiClient,
    private readonly applicationContext: ApplicationContext,
    @Optional() private readonly logger?: Logger,
  ) {
  }

  public getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.AD_SET_PRE_RESOLVE ]: 'onPreResolve',
      [ Events.AD_SET_POST_RESOLVE ]: 'onPostResolve',
    };
  }

  public async onPreResolve (event: AdSetResolveEvent): Promise<void> {
    this.logger?.debug(`Ad set ${event.getId()} onPreRender`);
  }

  public async onPostResolve (event: AdSetResolveEvent): Promise<void> {
    this.logger?.debug(`Ad set ${event.getId()} onPostRender`);

    // const adSet = event.getAdSet();

    // if (!adSet) {
    //   return;
    // }

    // await this.apiClient.registerEvent(null, {
    //   eventType: EventTypeEnum.AD_SET_LOAD,
    //   startTime: this.applicationContext.getStartTime(),
    // });
  }
}
